import React from "react";
import { Chip, Divider, MenuItem, Stack, Typography } from "@mui/material";
import { GlassPanel, ModernTextField } from "../styledComponents";

const DATE_FIELD_WIDTH = { xs: "100%", md: "50%" };
const VALUE_FIELD_WIDTH = { xs: "66.6667%", md: "41.6667%" };
const UNIT_FIELD_WIDTH = { xs: "33.3333%", md: "25%" };

const QUANTITATIVE_FIELDS = [
  { label: "Glucosa en orina", name: "glucosaOrina", units: ["mg/dL"] },
  {
    label: "Proteínas en orina",
    name: "proteinasOrina",
    units: ["mg/dL", "mg/24h"],
  },
  {
    label: "Hemoglobina en orina",
    name: "hemoglobinaOrina",
    units: ["CHP", "mg/dL"],
  },
  { label: "Urobilinógeno", name: "urobilinogeno", units: ["mg/dL"] },
];

const PRESENCE_FIELDS = [
  { label: "Cuerpos cetónicos", field: "cuerposCetonicos" },
  { label: "Pigmentos biliares", field: "pigmentosBiliares" },
  { label: "Nitritos", field: "nitritos" },
];

const ExamenGeneralOrina = ({ formValues, onChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    onChange(name, value);
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <GlassPanel>
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="overline" sx={{ letterSpacing: 3 }}>
            Análisis clínico
          </Typography>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Examen general de orina
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Captura los valores y hallazgos clave para correlacionarlos con el
            resto del expediente.
          </Typography>
          <Stack direction="row" spacing={1}>
            {["Fecha", "Valores", "Hallazgos"].map((tag) => (
              <Chip key={tag} label={tag} size="small" variant="outlined" />
            ))}
          </Stack>
        </Stack>

        <Divider />

        <Stack spacing={3}>
          <ModernTextField
            label="Fecha"
            name="fechaEGO"
            type="date"
            value={formValues.fechaEGO || ""}
            onChange={handleInputChange}
            fullWidth
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
            helperText="Última fecha registrada del examen"
            sx={{ width: DATE_FIELD_WIDTH }}
          />

          {QUANTITATIVE_FIELDS.map((input) => (
            <Stack key={input.name} spacing={1.5}>
              <Typography variant="subtitle2" color="text.secondary">
                {input.label}
              </Typography>
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                sx={{ flexWrap: "wrap" }}
              >
                <ModernTextField
                  label="Valor"
                  name={input.name}
                  type="number"
                  value={formValues[input.name] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: VALUE_FIELD_WIDTH }}
                />
                <ModernTextField
                  select
                  label="Unidad"
                  name={`${input.name}Medida`}
                  value={formValues[`${input.name}Medida`] || ""}
                  onChange={handleInputChange}
                  fullWidth
                  sx={{ width: UNIT_FIELD_WIDTH }}
                  SelectProps={{ displayEmpty: true }}
                >
                  <MenuItem value="">
                    <em>Selecciona</em>
                  </MenuItem>
                  {input.units.map((unit) => (
                    <MenuItem key={unit} value={unit}>
                      {unit}
                    </MenuItem>
                  ))}
                </ModernTextField>
              </Stack>
            </Stack>
          ))}

          {PRESENCE_FIELDS.map(({ label, field }) => {
            const value = formValues[`${field}Medida`] || "";
            return (
              <Stack key={field} spacing={1.5}>
                <Typography variant="subtitle2" color="text.secondary">
                  {label}
                </Typography>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <ModernTextField
                    select
                    label={label}
                    name={`${field}Medida`}
                    value={value}
                    onChange={handleInputChange}
                    fullWidth
                    sx={{ width: { xs: "100%", sm: "100%", md: "50%" } }}
                    SelectProps={{ displayEmpty: true }}
                  >
                    <MenuItem value="">
                      <em>Desconocido</em>
                    </MenuItem>
                    <MenuItem value="ausencia">Ausencia</MenuItem>
                    <MenuItem value="presencia">Presencia</MenuItem>
                  </ModernTextField>
                  {value === "presencia" && (
                    <Chip label="Presencia" color="success" variant="filled" />
                  )}
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      </Stack>
    </GlassPanel>
  );
};

export default ExamenGeneralOrina;
